import ApiClientRequest from "../ApiClientRequest";
import BaseApiClientException from "./BaseApiClientException";
import { ApiClientResponse } from "..";

class BadRequestException extends BaseApiClientException {
    static STATUS_CODE = 400;
    constructor(
        request: ApiClientRequest,
        response: ApiClientResponse<unknown>
    ) {
        super(
            "Bad request",
            BadRequestException.STATUS_CODE,
            request,
            response
        );
    }
}

export default BadRequestException;
